export const RATING = ['Not Good', 'Fair', 'Good', 'Very Good', 'Excellent'];
